import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import CloseIcon from '@mui/icons-material/Close'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'

import { useChatContext } from './ChatContext'

export const ChatHeader = () => {
    const { setOpen, resetSession, messages } = useChatContext()

    return (
        <Box
            sx={{
                backgroundColor: 'primary.main',
                padding: '14px 16px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                flexShrink: 0,
            }}
            data-test="chat-header"
        >
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '10px',
                    backgroundColor: 'rgba(58, 214, 129, 0.18)',
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0,
                }}
            >
                <SmartToyOutlinedIcon sx={{ fontSize: 20, color: 'secondary.main' }} />
            </Box>

            <Box sx={{ flex: 1 }}>
                <Typography sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>Experimentation Assistant</Typography>
            </Box>

            <Tooltip title="Start a new session">
                <span>
                    <IconButton
                        size="small"
                        onClick={resetSession}
                        disabled={messages.length <= 1}
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.08)',
                            borderRadius: '6px',
                            width: 30,
                            height: 30,
                            '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.16)' },
                            '&.Mui-disabled': { backgroundColor: 'rgba(255, 255, 255, 0.04)' },
                        }}
                        data-test="chat-new-session"
                    >
                        <AddCommentOutlinedIcon sx={{ fontSize: 17, color: 'rgba(255, 255, 255, 0.7)' }} />
                    </IconButton>
                </span>
            </Tooltip>

            <IconButton
                size="small"
                onClick={() => setOpen(false)}
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    borderRadius: '6px',
                    width: 30,
                    height: 30,
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.16)' },
                }}
                data-test="chat-close"
            >
                <CloseIcon sx={{ fontSize: 18, color: 'rgba(255, 255, 255, 0.7)' }} />
            </IconButton>
        </Box>
    )
}
